import ToastComponent from "./Toast.vue"
import {
  EventBus
} from "./toastEventBus"

const ToastPlugin = {
  install(Vue) {

    Vue.component('toast', ToastComponent)

    Vue.prototype.$toast = {

      info(msg) {
        EventBus.$emit('ToastMessage', 'info', msg)
      },

      warning(msg) {
        EventBus.$emit('ToastMessage', 'warning', msg)
      },

      success(msg) {
        EventBus.$emit('ToastMessage', 'success', msg)
      },

      error(msg) {
        EventBus.$emit('ToastMessage', 'error', msg)
      },

      close() {
        EventBus.$emit('ToastMessage', '', '')
      },

      update(msg) {
        EventBus.$emit('ToastMessage', 'update', msg)
      },
    }

  }
}

export default ToastPlugin